export const tableHeader = [
  {key: 'mnnName', label: 'МНН'},
  {key: 'tradeNameUnique', label: 'Торгова назва'},
  {key: 'type', label: 'Тип'},
  {key: 'dosage', label: 'Дозування'},
  {key: 'registerOfAvailableSeries', label: 'Серія/Каталожний \nномер'},
  {key: 'dueDate', label: 'Придатний до'},
  {key: 'balanceQuantity', label: 'Залишки'},
  {key: 'availableQuantity', label: 'Доступні \nзалишки'},
  {key: 'minUnit', label: 'Мін. облікова \nодиниця'},
  {key: 'organizationCode', label: 'Код ЄДРПОУ/ \nРНОКПП'},
  {key: 'institutionName', label: 'Назва закладу'},
  {key: 'sponsoredBy', label: 'Джерело \nнадходження'},
  // { key: "directionName", label: "Напрям" },
  {key: 'treatmentProgram', label: 'Напрям'},
  {key: 'quarantineQuantity', label: 'На карантині'},
  {key: 'redistributionOffer', label: 'Запропоновано \nна перерозподіл'},
  {key: 'availableBookingQuantity', label: 'Доступно \nдля бронювання'},
  {key: 'editedOn', label: 'Дата оновлення \nзапису'},
  {key: 'administrationName', label: 'Підвідомчість'},
  {key: 'productionDate', label: 'Дата \nвиробництва'},
  {key: 'atcCode', label: 'Код АТС (АТХ)'},
  {key: 'releaseForm', label: 'Форма випуску'},
  {key: 'pharmaName', label: 'Виробник'},
  {key: 'registrationCertificateNumber', label: 'Номер РП'},
];
export const tableSubHeader = [
  {key: 'mnnName', label: 'МНН'},
  {key: 'tradeName', label: 'Торгова назва'},
  {key: 'type', label: 'Тип'},
  {key: 'dosage', label: 'Дозування'},
  {key: 'series', label: 'Серія/Каталожний \nномер'},
  {key: 'dueDate', label: 'Придатний до'},
  {key: 'balanceQuantity', label: 'Залишки'},
  {key: 'availableQuantity', label: 'Доступні \nзалишки'},
  {key: 'minUnit', label: 'Мін. облікова \nодиниця'},
  {key: 'organizationCode', label: 'Код ЄДРПОУ/ \nРНОКПП'},
  {key: 'institutionName', label: 'Назва закладу'},
  {key: 'sponsoredBy', label: 'Джерело \nнадходження'},
  // { key: "directionName", label: "Напрям" },
  {key: 'treatmentProgram', label: 'Напрям'},
  {key: 'quarantineQuantity', label: 'На карантині'},
  {key: 'redistributionOffer', label: 'Запропоновано \nна перерозподіл'},
  {key: 'availableBookingQuantity', label: 'Доступно \nдля бронювання'},
  {key: 'editedOn', label: 'Дата оновлення \nзапису'},
  {key: 'administrationName', label: 'Підвідомчість'},
  {key: 'productionDate', label: 'Дата \nвиробництва'},
  {key: 'atcCode', label: 'Код АТС (АТХ)'},
  {key: 'releaseForm', label: 'Форма випуску'},
  {key: 'pharmaName', label: 'Виробник'},
  {key: 'registrationCertificateNumber', label: 'Номер РП'},
];

export const TableFilterKeys = {
  treatmentProgram: "treatment-program",
  sponsoredBy: "sponsor",
  organizationCode: "institution-tax",
  mnnName: "nomenclature",
  dueDate: "due-date",
  balanceQuantity: "balance-quantity",
  type: "type",
  releaseForm: "release-form",
  tradeNameUnique: "tradeNameUnique",
  registerOfAvailableDueDate: 'registerOfAvailableDueDate',
  registerOfAvailableSeries: 'registerOfAvailableSeries'
};
